import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FaqService {
  lang: string;
  headers = new HttpHeaders({
    'X-Offset': '0', // starting index
    'X-Limit': '200', // number of items you want
    'Accept-Language': 'ru',
  });

  constructor(private http: HttpClient) {
    const lang = localStorage.getItem('lang');
    this.lang = lang ? lang : 'ru';
    this.headers = this.headers.append('Accept-Language', this.lang);
  }

  getArticleCategories(): Observable<HttpResponse<any>> {
    return this.http
      .get(`/v1/dbp/business-frequently-asked-questions/article-categories`, {
        headers: this.headers,
        observe: `response`,
      })
      .pipe(
        catchError((error) => {
          console.error('Error fetching articles categories:', error);
          return throwError(error);
        })
      );
  }

  getArticles(): Observable<HttpResponse<any>> {
    return this.http
      .get(`/v1/dbp/business-frequently-asked-questions/articles`, {
        headers: this.headers,
        observe: `response`,
      })
      .pipe(
        catchError((error) => {
          console.error('Error fetching articles:', error);
          return throwError(error);
        })
      );
  }

  getAttachmentById(id: number): Observable<HttpResponse<any>> {
    return this.http
      .get(`/v1/dbp/business-frequently-asked-questions/attachments/` + id, {
        headers: this.headers,
        observe: `response`,
      })
      .pipe(
        catchError((error) => {
          console.error('Error fetching articles:', error);
          return throwError(error);
        })
      );
  }
}
